import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './auth/auth.component';
import { MainComponent } from './main/main.component';
import { authGuard } from './shared/guards/auth.guard';
import { notAuthGuard } from './shared/guards/not-auth.guard';

const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule), component: AuthComponent, canActivate: [authGuard] },
  { path: 's', loadChildren: () => import('./main/main.module').then(m => m.MainModule), component: MainComponent, canActivate: [notAuthGuard] },
  { path: '', redirectTo: 'auth', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
